import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'react-app-polyfill/ie11';

import React from 'react';
import ReactModal from 'react-modal';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import Root from './containers/Core/Root';
import store from './store';

require('./sass/style.scss');
require('./helpers/logger');

window.MAW = window.MAW || {};
const { basePath = '' } = window.MAW;

const root = document.getElementById('root');

ReactModal.setAppElement(root);

render(
  <Router basename={`${basePath}/devices`}>
    <Root store={store} />
  </Router>,
  root,
);
